import { IS_WHITE_LABELED } from '../../appConfig';
import React from 'react';
import { Container } from '@lib/nvstr-common-ui.es';
import styled from 'styled-components';

const Wrapper = styled.div`
  overflow: hidden;
  g {
    opacity: 0.3;
  }
  path {
    stroke: ${(props) => (props.isDarkMode ? props.theme.secondary.white : props.theme.primary.charcoal)};
  }
`;

export const TORNADO_LINES_ASPECT_RATIO = 1444 / 1306;

export const SizeableTornadoLines = ({ isDarkMode, height = 1306 }) => {
  // const defaultWidth  = '1444px';
  const width = TORNADO_LINES_ASPECT_RATIO * height;
  return (
    <Container>
      <Wrapper isDarkMode={isDarkMode}>
        <svg width={width} height={height} viewBox="0 0 1444 1306" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.3">
            <path
              d="M593.417 1C599.534 35.9497 621.125 68.6953 647.393 109.942C717.802 219.671 807.522 501.315 573.626 679.212C367.557 836.013 152.972 1026.35 71.5283 1305"
              stroke="#ECEAE7"
              strokeWidth="1.0001"
              strokeMiterlimit="10"
            />
            <path
              d="M535.963 1C542.08 35.9497 563.67 68.6953 589.939 109.942C660.348 219.671 853.822 501.315 619.806 679.212C413.737 836.013 82.3239 1026.35 1 1305"
              stroke="#ECEAE7"
              strokeWidth="1.0001"
              strokeMiterlimit="10"
            />
            <path
              d="M663.226 1305C657.109 1270.05 635.519 1237.3 609.25 1196.06C538.842 1086.33 449.121 804.685 683.018 626.788C889.086 469.987 1103.67 279.653 1185.11 1"
              stroke="#ECEAE7"
              strokeWidth="1.0001"
              strokeMiterlimit="10"
            />
            <path
              d="M713.004 1305C635.398 1273.83 352.684 901.19 742.031 687.871C1019.35 535.793 1267.76 307.675 1443 1"
              stroke="#ECEAE7"
              strokeWidth="1.0001"
              strokeMiterlimit="10"
            />
            <path
              d="M617.646 1305C452 1127.73 471.911 804.685 705.807 626.788C911.876 470.144 1196.87 317.279 1346.8 1"
              stroke="#ECEAE7"
              strokeWidth="1.0001"
              strokeMiterlimit="10"
            />
          </g>
        </svg>
      </Wrapper>
    </Container>
  );
};
